import React, { useState, useEffect } from 'react'
import Calendar from 'react-calendar'
import moment from 'moment-timezone'
import { useDispatch, useSelector } from 'react-redux'
import { slotActions } from '../../../services/slotSlice'
import Backdrop from '../../../UI/Backdrop'
import CloseButton from '../../../UI/CloseButton'
import { useGetTimeSlotsMutation } from '../../../services/coachApi'
import { useFreeBookingMutation } from '../../../services/chatApi'
import { toast, ToastContainer } from 'react-toastify'
import loader from '../../../assets/images/loader.gif'
import BookingError from './Popups/BookingError'
import Feedback from './Popups/Feedback'
import { useNavigate, useParams } from 'react-router-dom'
const PlanModal = ({closeModal,planReservation,triggerRefresh}) => {
  const dispatch = useDispatch()
  
 
  const coach_id = window.location.pathname.split('/').pop()
   console.log(coach_id);
  const [selectedDate, setSelectedDate] = useState(new Date())
   const [message, setMessage] = useState('')
  const [selectedTime, setSelectedTime] = useState('')
  const [bookingLoading, setBookingLoading] = useState(false);
   const [errorMessage, setErrorMessage] = useState('')
    const [errorBooking, setErrorBooking] = useState(false)
      const [feedback, setFeedback] = useState(false)
      const [feedbackcoachId,setFeedbackCoachId]=useState();
      const [feedbackBookId,setFeedbackBookId]=useState();
            const navigate = useNavigate()
  const userDetails=useSelector(state=>state.userReducer)
  const slots = useSelector((state) => state.slotReducers.slots || [])
  const bookedSlots = useSelector((state) => state.slotReducers.booking || [])
  const leaveSlots = useSelector((state) => state.slotReducers.leaves || [])
  const userTimezone = useSelector((state) => state.userReducer.timezone) 

   console.log(planReservation);
 
  
  const [freebooking]=useFreeBookingMutation()
   const [value, setValue] = useState(new Date())
     const [
            getTimeSlots,
            { isLoading: slotsLoading, isError: getSlotsError, error },
        ] = useGetTimeSlotsMutation() 
const coachId=planReservation?.coach_id || coach_id;
const categoryId=planReservation?.plan_details?.category
  // Format date as YYYY-MM-DD for API
  function formatDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day

        return [year, month, day].join('-')
    }


  const handleClick = async () => {
        const formData = new FormData()
        formData.append('date', formatDate(selectedDate))
        formData.append('coach_id', coachId)
        formData.append('category_id', categoryId)
// console.log(formatDate(selectedDate));

        try {
            const response = await getTimeSlots(formData)
            const data =response.data.data

            // console.log(data.slots)
            // console.log('Resssssssss', response)
            if (response.data.code === 'Success') {
               const deviceTimezone = localStorage.getItem('device_timezone')
                 const userTimezone = userDetails?.user?.data?.timezone?.name || deviceTimezone ;
                //  console.log(userTimezone);
                 

const slotTimes = data?.slots?.map((s) => {
  const utcDateTime = moment.utc(`${s.session_date} ${s.slot}`, 'YYYY-MM-DD HH:mm');

  const localMoment = userTimezone
    ? utcDateTime.clone().tz(userTimezone)
    : utcDateTime.local();

  return {
    time24: localMoment.format('HH:mm'),
     time12: localMoment.format('hh:mm A'), 
    available: s.is_slot_available,
  };
});
// console.log('Converted local slot times:', slotTimes);
                // const slotTimes=data?.slots?.map((s)=>s.slot)
                // console.log(slotTimes);
                
                dispatch(slotActions.getSlots(slotTimes))

                //vk
                dispatch(slotActions.getBookedSlots(data.booking))
                dispatch(slotActions.getLeaveSlots(data.leaves))

                if (data.slots.length === '') {
                    setMessage('No slots found! Try changing date.')
                } else {
                    setMessage('')
                }
            } else {
                // console.log(response.error)
                dispatch(slotActions.getSlots([]))

                //vk
                dispatch(slotActions.getBookedSlots([]))
                dispatch(slotActions.getLeaveSlots([]))
            }
        } catch (error) {
            // console.error('Errrr', error.message)
        }
    }


    useEffect(() => {
        handleClick()
        //eslint-disable-next-line
    }, [selectedDate])
  // Fetch slots for selected date (you can use your existing action/mutation)
  const fetchSlots = async () => {
    try {
     

    } catch (error) {
      // console.error('Error fetching slots:', error)
      dispatch(slotActions.getSlots([]))
    }
  }

  useEffect(() => {
    fetchSlots()
  }, [selectedDate])

  // Current time for graying out past slots today
  const currentTime = moment(new Date(), 'HH:mm')

  // Handle clicking on time slot
  const onSelectTimeSlot = (time) => {
    setSelectedTime(time)
  }

 

const bookAppointment = async () => {
  setBookingLoading(true);

  try {
    const payload = {
      category_id: categoryId,
      date: formatDate(selectedDate),
      time_slot: selectedTime,
      coach_id: coachId,
      plan_reservation_id: planReservation?.id,
    };

    const res = await freebooking(payload).unwrap();
 

    toast.success(res?.message);
    setBookingLoading(false);
    if(triggerRefresh){
    
      
 triggerRefresh();
    }
     window.dispatchEvent(new CustomEvent('free-consultation-booked'))
    
    closeModal();

  } catch (err) {
    // console.log(err);
    toast.error(err?.data?.message)
   
    setBookingLoading(false);

    const errorMsg = err?.data?.data?.error?.[0];

 const coachIdFromError = err?.data?.data_key?.[0]?.[1];
 const coachBookingId=err?.data?.data_key?.[0]?.[0];
//  console.log(coachIdFromError,coachBookingId);
 setFeedbackCoachId(coachIdFromError)
 setFeedbackBookId(coachBookingId)
    if (errorMsg === 'Please give previous session a rating.') {
      setErrorMessage(errorMsg);
      setErrorBooking(true);   // ✅ NOW this will be true
      // setFeedback(true);
    } else {
      // toast.error(err?.data?.message || 'Something went wrong');
      setErrorMessage(err?.data?.message)
      setErrorBooking(true);
    }
closeModal();
   
  }
};

// console.log(errorBooking);
// console.log(errorMessage);

  return (
    <>
      {(errorBooking || feedback)&&<Backdrop />}
      {/* <ToastContainer hideProgressBar /> */}
       {errorBooking && (
                    <BookingError
                        
                        setFeedback={setFeedback}
                        setErrorBooking={setErrorBooking}
                        onClickNo={() => {setErrorBooking(false); 
                          navigate(0);
                          
                        }}
                        message={errorMessage}
                    />
                     
                )}
                {feedback && (
        <Feedback
          setFeedback={setFeedback}
          setErrorBooking={setErrorBooking}
          feedbackcoachId={feedbackcoachId}
          feedbackBookId={feedbackBookId}
          closeModal={() => {
            closeModal();
            setFeedback(false);
            setErrorBooking(false);
          }}
        />
      )}
      {!errorBooking && !feedback &&<div className="fixed inset-0 z-[999] flex justify-center items-center bg-black bg-opacity-60">
        <div className="bg-white rounded-xl w-[500px] max-w-full p-4 relative">
          <div className="flex justify-between items-center mb-4">
            <h2 className="font-bold text-lg">Book Your Appointment</h2>
            <CloseButton onClick={closeModal} className='cursor-pointer'/>
          </div>

          <Calendar
            onChange={setSelectedDate}
            value={selectedDate}
            minDate={new Date()}
            maxDate={new Date(Date.now() + 6 * 24 * 60 * 60 * 1000)} // 7 days ahead
            className="mx-auto"
          />
<div className='flex items-center justify-center py-1 text-gray-400'>Hey there! You're on {localStorage.getItem('device_timezone')} timezone</div>

          <div className="mt-4 flex flex-wrap gap-2 justify-center max-h-[90px] overflow-y-auto">
            {slots.length === 0 && <p>No slots available for this date.</p>}

            {slots.map((slot, idx) => {
              // Parse slot time in user's timezone or local time
              const slotTimeMoment = userTimezone
                ? moment.tz(`${formatDate(selectedDate)} ${slot.time}`, 'YYYY-MM-DD HH:mm', userTimezone)
                : moment(`${formatDate(selectedDate)} ${slot.time}`, 'YYYY-MM-DD HH:mm')

              const isPast =
                moment(formatDate(selectedDate)).isSame(moment(), 'day') &&
                slotTimeMoment.isBefore(currentTime)

              const isBooked = bookedSlots.includes(slot.time24)
              const isLeave = leaveSlots.includes(slot.time24)

              const disabled = isPast || isBooked || isLeave || !slot.available

              return (
                <button
                  key={idx}
                  disabled={disabled}
                  onClick={() => onSelectTimeSlot(slot.time24)}
                  className={`px-4 py-2 rounded-full border ${
                    selectedTime === slot.time24 ? 'bg-orange text-white' : 'text-gray-700 border-gray-400'
                  } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                >
                  {slot.time12}
                </button>
              )
            })}
          </div>

          <div className="mt-6 flex justify-center">
            <button
              onClick={bookAppointment}
              disabled={!selectedTime}
              className="bg-[#FFDBB0] text-[#F77F11] rounded-full px-6 py-2 font-semibold disabled:opacity-50"
            >
             {bookingLoading ? (
    <img
      src={loader}
      className="w-8 h-8 mx-auto"
      alt="Loading..."
    />
  ) : (
    'Confirm'
  )}
            </button>
          </div>
        </div>
      </div>}
    </>
  )
}

export default PlanModal